export default __webpack_public_path__ + "static/03-02-math-data-analysis-976135263669a9b8e147b07c1ce9c8a6.mp4";